import React, {useState} from "react";
import styles, {C} from "../styles";
import {formatDate} from "../utils";
import {apiReplyHelpRequest, apiCloseHelpRequest} from "../api/help";
import {useConfirm} from "../components/FeedbackProvider";

export default function AidePage({helpRequests, onRefresh}) {
    const confirm = useConfirm();
    const [replyDrafts, setReplyDrafts] = useState({});
    const [sendingReplyFor, setSendingReplyFor] = useState(null);

    function sendReply(requestId) {
        const content = (replyDrafts[requestId] || "").trim();
        if (content === "" || sendingReplyFor === requestId) return;
        setSendingReplyFor(requestId);
        apiReplyHelpRequest(requestId, content).then(() => {
            setSendingReplyFor(null);
            setReplyDrafts(prev => ({...prev, [requestId]: ""}));
            onRefresh();
        });
    }

    async function closeRequest(requestId) {
        if (!(await confirm("Classer cette demande comme traitée ?"))) return;
        apiCloseHelpRequest(requestId).then(() => onRefresh());
    }

    return (
        <>
            <h2 style={{fontFamily: "'Fraunces', serif"}}>🆘 Aide</h2>
            {helpRequests.length === 0 ? (
                <p>Aucune demande d'aide.</p>
            ) : (
                helpRequests.map(request => (
                    <div key={request.id} style={styles.card}>
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8}}>
                            <div>
                                <strong>{request.pseudo}</strong>
                                {request.phone && <span style={{marginLeft: 10, fontSize: 13, color: C.textMuted}}>📞 {request.phone}</span>}
                            </div>
                            <span style={{
                                fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
                                backgroundColor: request.status === "closed" ? C.border : C.primaryLight,
                                color: request.status === "closed" ? C.textMuted : C.primary,
                            }}>
                                {request.status === "closed" ? "⚪ Classée" : "🟢 Ouverte"}
                            </span>
                        </div>
                        <p style={{fontSize: 12, color: C.textMuted, marginBottom: 10}}>{formatDate(request.created_at)}</p>
                        {request.messages.map(msg => (
                            <div key={msg.id} style={{
                                display: "flex",
                                justifyContent: msg.sender === "admin" ? "flex-end" : "flex-start",
                                marginBottom: 6,
                            }}>
                                <div style={{
                                    maxWidth: "80%",
                                    padding: "8px 12px",
                                    borderRadius: 10,
                                    fontSize: 13,
                                    backgroundColor: msg.sender === "admin" ? C.primaryLight : C.bg,
                                    color: C.text,
                                }}>
                                    {msg.content}
                                </div>
                            </div>
                        ))}
                        <div style={{display: "flex", gap: 6, marginTop: 8}}>
                            <input
                                value={replyDrafts[request.id] || ""}
                                onChange={e => setReplyDrafts(prev => ({...prev, [request.id]: e.target.value}))}
                                placeholder="Répondre…"
                                style={{
                                    flex: 1, padding: "8px 10px", borderRadius: 8,
                                    border: `1.5px solid ${C.border}`, boxSizing: "border-box",
                                    fontSize: 13, color: C.text, fontFamily: "inherit",
                                }}
                            />
                            <button
                                onClick={() => sendReply(request.id)}
                                disabled={(replyDrafts[request.id] || "").trim() === "" || sendingReplyFor === request.id}
                                style={{
                                    backgroundColor: C.primary, color: "white", border: "none",
                                    padding: "8px 14px", borderRadius: 8, cursor: "pointer",
                                    fontWeight: 600, fontSize: 13,
                                    opacity: ((replyDrafts[request.id] || "").trim() === "" || sendingReplyFor === request.id) ? 0.6 : 1,
                                }}
                            >
                                Répondre
                            </button>
                            {request.status === "open" && (
                                <button onClick={() => closeRequest(request.id)} style={styles.dangerButton}>
                                    Classer
                                </button>
                            )}
                        </div>
                    </div>
                ))
            )}
        </>
    );
}
